/**
 * IconInformatics component
 *
 * @author: exode <hello@exode.ru>
 */

import React, { SVGProps } from 'react';


const IconInformatics = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg"
             height={858.953}
             viewBox="0 0 644.215 644.215"
             width={858.953} {...props}>
            <path d="M320.797 409.816a26.19 26.19 0 0 1 23.418 14.477l53.894 152.543c6.465 12.934 1.223 28.66-11.71 35.125a26.177 26.177 0 0 1-35.125-11.707L297.378 447.71c-6.469-12.934-1.227-28.66 11.707-35.129a26.208 26.208 0 0 1 11.71-2.766Zm0 0"
                  style={{
                      stroke: 'none',
                      fillRule: 'nonzero',
                      fill: '#ffa300',
                      fillOpacity: 1,
                  }}/>
            <path d="M336.637 497.637h29.273c8.082 0 14.637 6.55 14.637 14.636 0 8.082-6.555 14.633-14.637 14.633h-29.273c-8.082 0-14.637-6.55-14.637-14.633 0-8.082 6.555-14.636 14.637-14.636Zm0 0"
                  style={{
                      stroke: 'none',
                      fillRule: 'nonzero',
                      fill: '#f98b00',
                      fillOpacity: 1,
                  }}/>
            <path d="M325.055 409.816a26.19 26.19 0 0 0-23.418 14.477L178.434 606.109c-6.465 12.934-1.223 28.66 11.71 35.125a26.177 26.177 0 0 0 35.125-11.707l123.208-181.816c6.464-12.934 1.222-28.66-11.711-35.129a26.208 26.208 0 0 0-11.711-2.766Zm0 0"
                  style={{
                      stroke: 'none',
                      fillRule: 'nonzero',
                      fill: '#ffbe00',
                      fillOpacity: 1,
                  }}/>
            <path d="M320.797 409.816a26.19 26.19 0 0 1 23.418 14.477l123.203 181.816c6.469 12.934 1.223 28.66-11.711 35.125a26.177 26.177 0 0 1-35.125-11.707L297.379 447.711c-6.469-12.934-1.227-28.66 11.707-35.129a26.208 26.208 0 0 1 11.71-2.766Zm0 0"
                  style={{
                      stroke: 'none',
                      fillRule: 'nonzero',
                      fill: '#ffbe00',
                      fillOpacity: 1,
                  }}/>
            <path d="M58.547 29.273h526.906C617.79 29.273 644 55.484 644 87.82v351.27c0 32.336-26.21 58.547-58.547 58.547H58.547C26.21 497.637 0 471.426 0 439.09V87.82c0-32.336 26.21-58.547 58.547-58.547Zm0 0"
                  style={{
                      stroke: 'none',
                      fillRule: 'nonzero',
                      fill: '#163969',
                      fillOpacity: 1,
                  }}/>
            <path d="M526.91 117.09H175.637c-16.168 0-29.274 13.105-29.274 29.273V439.09c0 16.168 13.106 29.273 29.274 29.273h268.476a58.545 58.545 0 0 0 41.399-17.148l53.523-53.524a58.529 58.529 0 0 0 17.149-41.394V146.363c-.004-16.168-13.11-29.273-29.274-29.273Zm0 0"
                  style={{
                      stroke: 'none',
                      fillRule: 'nonzero',
                      fill: '#002755',
                      fillOpacity: 1,
                  }}/>
            <path d="M585.453 29.273H87.816c-8.082.008-14.629 6.567-14.62 14.653.007 8.07 6.55 14.613 14.62 14.62h497.637c16.16.017 29.254 13.114 29.274 29.274v351.27c-.016 16.16-13.114 29.254-29.274 29.273h-8.308c-8.082 0-14.637 6.555-14.637 14.637 0 8.086 6.554 14.637 14.637 14.637h8.308c32.336 0 58.547-26.211 58.547-58.543V87.816c0-32.332-26.21-58.543-58.547-58.543Zm0 0"
                  style={{
                      stroke: 'none',
                      fillRule: 'nonzero',
                      fill: '#002755',
                      fillOpacity: 1,
                  }}/>
            <path d="M444.113 439.09H117.09c-16.164 0-29.274-13.106-29.274-29.274V87.82c0-16.168 13.106-29.273 29.274-29.273h409.82c16.164 0 29.27 13.105 29.27 29.273v239.203a58.557 58.557 0 0 1-17.145 41.399l-53.523 53.523a58.557 58.557 0 0 1-41.399 17.145Zm0 0"
                  style={{
                      stroke: 'none',
                      fillRule: 'nonzero',
                      fill: '#ccd4ff',
                      fillOpacity: 1,
                  }}/>
            <path d="M409.816 292.727c16.168 0 29.274 13.105 29.274 29.273v58.547c0 16.164-13.106 29.27-29.27 29.27-16.168 0-29.273-13.106-29.273-29.27V322c0-16.168 13.105-29.273 29.27-29.273Zm0 0"
                  style={{
                      stroke: 'none',
                      fillRule: 'nonzero',
                      fill: '#a4b1ff',
                      fillOpacity: 1,
                  }}/>
            <path d="M117.09 87.82h409.82c16.164 0 29.27 13.106 29.27 29.27 0 16.168-13.106 29.273-29.27 29.273H117.09c-16.164 0-29.27-13.105-29.27-29.273-.004-16.164 13.106-29.27 29.27-29.27Zm0 0"
                  style={{
                      stroke: 'none',
                      fillRule: 'nonzero',
                      fill: '#b8c2ff',
                      fillOpacity: 1,
                  }}/>
            <path d="M117.09 0h409.82c32.332 0 58.543 26.21 58.543 58.547 0 32.332-26.21 58.543-58.543 58.543H117.09c-32.332 0-58.543-26.211-58.543-58.543C58.547 26.21 84.757 0 117.09 0ZM439.09 292.727h75.691c22.867 0 41.399 18.535 41.399 41.398 0 10.98-4.36 21.508-12.125 29.273l-63.567 63.567a41.386 41.386 0 0 1-29.273 12.125c-22.863 0-41.399-18.535-41.399-41.399V322c0-16.168 13.106-29.273 29.274-29.273Zm0 0"
                  style={{
                      stroke: 'none',
                      fillRule: 'nonzero',
                      fill: '#eff2ff',
                      fillOpacity: 1,
                  }}/>
            <path d="M234.184 223v80.91c0 26.156 21.203 47.363 47.363 47.363a47.394 47.394 0 0 0 21.18-5l80.91-40.453a47.365 47.365 0 0 0 26.18-42.367 47.363 47.363 0 0 0-26.18-42.363l-80.91-40.453a47.394 47.394 0 0 0-21.18-5c-26.16 0-47.363 21.207-47.363 47.363Zm0 0"
                  style={{
                      stroke: 'none',
                      fillRule: 'nonzero',
                      fill: '#4cc66e',
                      fillOpacity: 1,
                  }}/>
            <path d="M381.777 222.395c-8.082-.008-14.64 6.542-14.648 14.625 0 4.675 2.23 9.07 6.004 11.828 8.066 5.898 9.824 17.218 3.926 25.285a18.126 18.126 0 0 1-6.512 5.504l-80.91 40.453c-8.934 4.469-19.801.848-24.27-8.09a18.063 18.063 0 0 1-1.91-8.09v-8.953c.008-8.082-6.539-14.644-14.621-14.652-8.086-.008-14.645 6.539-14.652 14.62v8.985c0 26.156 21.207 47.363 47.363 47.363a47.37 47.37 0 0 0 21.183-5l80.907-40.453a47.363 47.363 0 0 0 26.18-42.363v-.531l-.005-.098v-.133l-.003-.062v-.137l-.004-.062v-.11l-.004-.027v-.094l-.004-.035v-.102l-.004-.062v-.04l-.004-.058v-.039l-.004-.058v-.043l-.004-.079v-.015l-.004-.098v-.035l-.004-.062-.003-.04v-.058l-.004-.04-.004-.062v-.035l-.004-.062v-.035l-.004-.098-.004-.016-.004-.078v-.039l-.004-.062-.004-.036-.004-.062v-.035l-.004-.067-.003-.03c0-.024-.004-.052-.004-.071v-.028c-.004-.035-.004-.062-.008-.097v-.028l-.004-.066-.004-.039-.004-.059-.004-.043-.004-.054-.004-.043-.003-.055-.004-.043-.004-.07-.004-.024-.004-.093-.004-.04-.004-.058-.004-.043-.004-.055-.004-.043-.004-.054-.003-.043-.004-.055-.004-.043-.008-.063-.008-.125-.004-.042-.008-.051-.004-.047-.003-.05-.012-.142-.004-.054-.004-.043-.008-.067-.008-.07-.011-.14-.008-.055-.004-.043-.004-.051-.004-.043-.008-.05-.007-.094-.012-.09-.004-.051c0-.016-.004-.031-.004-.047l-.008-.047-.004-.047-.008-.047-.003-.046-.004-.051-.004-.043-.008-.055-.004-.031c-.004-.04-.012-.078-.016-.117l-.003-.032-.008-.054-.004-.04-.008-.058-.004-.035-.008-.059-.004-.035-.007-.058-.004-.032-.043-.308-.004-.024-.008-.066-.004-.027-.012-.063-.011-.094-.004-.023-.035-.23-.004-.016-.012-.067-.004-.023-.008-.067-.004-.027-.011-.066-.004-.02-.012-.074a5.572 5.572 0 0 0-.043-.25v-.012l-.012-.074-.004-.016-.015-.074v-.015c-.004-.024-.012-.051-.016-.075v-.011l-.058-.325-.004-.015-.012-.074-.004-.016-.012-.074-.004-.012c-.027-.14-.054-.281-.078-.422l-.004-.004-.015-.078v-.012l-.016-.078v-.004c-.031-.14-.059-.28-.09-.425v-.004l-.015-.082v-.004a47.4 47.4 0 0 0-18.41-28.512 14.563 14.563 0 0 0-8.622-2.816Zm0 0"
                  style={{
                      stroke: 'none',
                      fillRule: 'nonzero',
                      fill: '#14a142',
                      fillOpacity: 1,
                  }}/>
            <path d="M117.09 58.547h409.82c16.164 0 29.27 13.105 29.27 29.27 0 16.167-13.106 29.273-29.27 29.273H117.09c-16.164 0-29.27-13.106-29.27-29.274-.004-16.164 13.106-29.27 29.27-29.27Zm0 0"
                  style={{
                      stroke: 'none',
                      fillRule: 'nonzero',
                      fill: '#dfe5ff',
                      fillOpacity: 1,
                  }}/>
            <path d="M322 234.184c0 16.164-13.105 29.27-29.273 29.27-16.164 0-29.274-13.106-29.274-29.27 0-16.168 13.11-29.274 29.274-29.274 16.168 0 29.273 13.106 29.273 29.274Zm0 0"
                  style={{
                      stroke: 'none',
                      fillRule: 'nonzero',
                      fill: '#b7e8c4',
                      fillOpacity: 1,
                  }}/>
            <path d="M248.816 497.637h29.274c8.086 0 14.637 6.55 14.637 14.636 0 8.082-6.551 14.633-14.637 14.633h-29.274c-8.082 0-14.632-6.55-14.632-14.633 0-8.082 6.55-14.636 14.632-14.636ZM365.91 497.637h29.274c8.082 0 14.632 6.55 14.632 14.636 0 8.082-6.55 14.633-14.632 14.633H365.91c-8.086 0-14.637-6.55-14.637-14.633 0-8.082 6.551-14.636 14.637-14.636Zm0 0"
                  style={{
                      stroke: 'none',
                      fillRule: 'nonzero',
                      fill: '#ffa300',
                      fillOpacity: 1,
                  }}/>
            <path d="M395.184 117.09H483c8.086 0 14.637 6.555 14.637 14.637s-6.551 14.636-14.637 14.636h-87.816c-8.086 0-14.637-6.554-14.637-14.636 0-8.082 6.55-14.637 14.637-14.637ZM278.09 117.09h29.273c8.086 0 14.637 6.555 14.637 14.637s-6.55 14.636-14.637 14.636H278.09c-8.082 0-14.637-6.554-14.637-14.636 0-8.082 6.555-14.637 14.637-14.637Zm0 0"
                  style={{
                      stroke: 'none',
                      fillRule: 'nonzero',
                      fill: '#a4b1ff',
                      fillOpacity: 1,
                  }}/>
        </svg>
    );
};


export { IconInformatics };
